import { createSlice } from '@reduxjs/toolkit';

const confirmDeleteSlice = createSlice({
  name: 'confirmDelete',
  initialState: {
    isShow: false,
    message: [],
    callback: {},
  },
  reducers: {
    open: (state, { payload: { message, callback } }) => {
      state.isShow = true;
      state.message = message;
      state.callback = callback;
    },
    close: state => {
      state.isShow = false;
    },
  },
});

export const { open, close } = confirmDeleteSlice.actions;
export default confirmDeleteSlice.reducer;
